import React from 'react'

import {
    Menu,
    Container,
    Dropdown,
    Header,
    Grid,
    Sidebar,
    Icon,
    Image,
    Button,
    Table,
} from 'semantic-ui-react'
import GridRow from 'semantic-ui-react/dist/commonjs/collections/Grid/GridRow';
import { CSVDownload, CSVLink } from "react-csv";
import ReactTable from "react-table";
import "./style.css";
import "react-table/react-table.css"



class ReportTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSearch:false
        };
        this.renderTableHeader = this.renderTableHeader.bind(this);
        this.renderTableData = this.renderTableData.bind(this);

    }

    // renderTableHeader() {
    //     const { reportData } = this.props
    //     return (
    //         // Object.keys(reportData).length !== 0
    //         //     ?
    //         reportData.header ?
    //             reportData.header.map((data, key) => {
    //                 return (
    //                     <Table.HeaderCell textAlign="left" style={styles.headerCell} key={key}>
    //                         {data}
    //                     </Table.HeaderCell>
    //                 )
    //             })
    //             : null
    //     )
    // }


    renderTableHeader() {
        const { reportData } = this.props
        const tempArr = [];
        if (reportData.header) {
            for (var i = 0; i < reportData.header.length; i++) {
                tempArr.push({
                    Header: reportData.header[i],
                    accessor: reportData.keys[i],
                    Cell: props => <span style={{ width: 80 }}>{props.value}</span> // Custom cell components!

                })
            }
        }
        return tempArr;
    }

    renderTableData() {
        const { reportData } = this.props
        const tempArr = [];
        if (reportData.data) {
            let repName = this.props.reportName;
            for (var i = 0; i < reportData.data.length; i++) {
                let obj = reportData.data[i]
                let tempObj = {}
                for (var key in obj) {
                    if (typeof (obj[key]) === 'number') {
                        if (key.includes('Quantity') || key.includes('Qty')) {
                            tempObj[key] = parseFloat(obj[key].toFixed(6))
                        }
                        else if (repName == 'Inventory Tracking Report' || repName == 'Key Item Running Inventory Report') {
                            tempObj[key] = parseFloat(obj[key].toFixed(6))
                        }
                        else if (Math.round(obj[key]) == obj[key]) {
                            tempObj[key] = obj[key] // Cell-value is an integer...
                        }
                        else {
                            tempObj[key] = obj[key].toFixed(2)
                        }
                    }
                    else {
                        tempObj[key] = obj[key] === true ? JSON.stringify(obj[key]) : obj[key]
                    }
                }
                tempArr.push(tempObj)
            }
        }
        return tempArr;
    }

    render() {
        const { reportData, showSearchPane, handleSearchPane, reportDownloadName, reportList } = this.props

        const csvData = () => {
            let temp = [];
            let data;
            let reportData_data = reportData.data || [];
            let reportData_keys = reportData.keys || [];

            /* Code for handling the floating number */
            const tempArr = [];
            if (reportData.data) {
                let repName = this.props.reportName;
                for (var i = 0; i < reportData.data.length; i++) {
                    let obj = reportData.data[i]
                    let tempObj = {}
                    for (var key in obj) {
                        if (typeof (obj[key]) === 'number') {
                            if (key.includes('Quantity') || key.includes('Qty')) {
                                tempObj[key] = obj[key]
                            }
                            else if (repName == 'Inventory Tracking Report' || repName == 'Key Item Running Inventory Report') {
                                tempObj[key] = parseFloat(obj[key].toFixed(8))
                            }
                            else if (Math.round(obj[key]) == obj[key]) {
                                tempObj[key] = obj[key] // Cell-value is an integer...
                            }
                            else {
                                tempObj[key] = obj[key].toFixed(2)
                            }
                        }
                        else {
                            tempObj[key] = obj[key] === true ? JSON.stringify(obj[key]) : obj[key]
                        }

                        // tempObj[key] = obj[key]
                    }
                    tempArr.push(tempObj)
                }
            }
            return tempArr;
        };

        return (
            <Grid columns={1}>
                <Grid.Column>
                    <Grid.Row style={styles.heading}>
                        <div style={{ width: '100%', }}>
                            <Header as="h3" style={{ ...styles.heading, display: 'inline' }} >
                                {this.props.reportName ? this.props.reportName : null}
                            </Header>
                            <div className={reportData.data && reportData.data.length > 0 ?
                                   "float-right iconMainBox" : "float-right"} >
                                {!showSearchPane ? <Icon style={{ cursor: 'pointer' }} onClick={handleSearchPane} color="black" type="font-awesome" name="chevron down" /> :
                                    <Icon style={{ cursor: 'pointer' }} onClick={handleSearchPane} color="black" type="font-awesome" name="chevron up" />}
                                {reportData.data && reportData.data.length > 0 ? <React.Fragment>
                                <CSVLink
                                    filename={reportDownloadName ? reportDownloadName : 'Oscar Dashboard Report.csv'}
                                    headers={reportData.keys}
                                    // target=""
                                    data={csvData()}
                                >
                                    <Icon name="download" color="black" type="font-awesome" />
                                </CSVLink>
                                <Icon style={{ cursor: 'pointer' }} onClick={()=>{
                                    this.setState({
                                        showSearch:!this.state.showSearch
                                    })
                                }} name="search" color="black" type="font-awesome" />
                                </React.Fragment>

                                    : null}
                            </div>
                        </div>
                    </Grid.Row>
                    <Grid.Row>
                        <div className="customScroll">
                            {Object.keys(reportData).length ?
                                <ReactTable
                                    // data={this.props.reportData.data}
                                    data={this.renderTableData()}
                                    // data={data}
                                    columns={this.renderTableHeader()}
                                    // columns={this.props.reportData.header}
                                    defaultPageSize={7}
                                    pageSizeOptions={[7, 10, 20, 25, 50, 100]}
                                    filterable={this.state.showSearch}
                                    defaultFilterMethod={(filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ?
                                        RegExp("\\b" + filter.value, "i").test(String(row[id])) : true
                                    }}
                                    resizable={true}
                                    className="tabelMain ui sortable celled"
                                /> : null}
                            {/* <div className="scrollable-div_container" style={{ overflow: 'scroll' }}>

                            <Table fixed style={styles.mainTable}>

                                <Table.Header>
                                    <Table.Row style={styles.headerRow}>
                                        {this.renderTableHeader()}
                                    </Table.Row >
                                </Table.Header>
                                <Table.Body>
                                    {this.renderTableData()}
                                </Table.Body>
                            </Table>
                        </div> */}
                        </div>
                    </Grid.Row>
                </Grid.Column>
            </Grid >
        )
    }

}


const styles = {
    mainTable: {
        borderWidth: 0,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: "transparent",

    },
    tablerow: {
        textAlign: "center",
        fontFamily: "Roboto",
        backgroundColor: "none"
    },
    headerCell: {
        width: 200,
        backgroundColor: "#ECF3FA",
        color: "#999",
        fontSize: 14,
        fontWeight: 300,
        paddingTop: 15,
        paddingBottom: 15,
        borderColor: "#c1c1c5",
        borderWidth: 0.7,
        borderRadius: 0,
        // paddingRight:60,
        // marginRight:50
    },
    tableCellfirst: {
        width: 200,
        backgroundColor: "#F9F9FE",
        color: "#999",
        fontSize: 14,
        paddingTop: 15,
        paddingBottom: 15,
        borderTopWidth: 0.5,
        borderTopColor: "#C9C9C9",
        // paddingRight:60,

    },
    tableCell: {
        width: 200,
        backgroundColor: "#F9F9FE",
        color: "#313131",
        fontSize: 14,
        paddingTop: 25,
        paddingBottom: 25,
        borderTopWidth: 0.5,
        borderTopColor: "#C9C9C9",
        // paddingRight:60,

    },
    headerRow: {
        textAlign: "center",
        fontFamily: "Roboto"
    },
    heading: {
        // fontSize: 16,
        color: "rgb(102, 104, 116)",
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 20,
        // display: "flex",
        // justifyContent: "space-between",
        fontWeight: 400,
        // textTransform: "uppercase",
        fontFamily: "Roboto"
    }
}

export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/ReportTable/index.js